import React, { Fragment, useState } from "react";

import { auth } from "../../Firebase/firebase";
import classes from "./WishList.module.css";
import camera from "../../assets/svg/camera.svg";
import heart from "../../assets/svg/redHeart.svg";
import Yellowstar from "../../assets/svg/Yellowstar.svg";
import EmptyYellowstar from "../../assets/svg/EmptyYellowstar.svg";
import Like from "../../assets/svg/like.svg";
import carImg from "../../assets/Img/carIMg.png";
import unKnownDealer from "../../assets/Img/unKnownDealer.jpg";
import doubleQoute from "../../assets/Img/doubleQoute.png";
import Spinner from "../UI/spinner/Spinner";

const WishList = (props) => {
    const [currentItemToDel, setCurrentItemToDel] = useState('');
    let wishItem = null;
    let tailer
    if (props.wishList) {
        wishItem = props.wishList.data.map(
            item => {
                const { model } = item
                let mediaImg = carImg;
                if (model.media.length !== 0) {
                    try {
                        mediaImg = model.media.filter(img => {
                            if (img.name === "video") {
                                return { url: "https://storage.googleapis.com/pcari-71145.appspot.com/media/png/HwN1Eapr6U.png" }
                            }
                            return img.name === 'front';
                        })[0].url;
                    } catch (error) {
                        mediaImg = model.media[0].url
                    }
                    tailer = mediaImg.slice(-4);
                }
                return (
                    <div className={classes.ListViewItem} key={model.id} >
                        {props.removing && currentItemToDel===model.id ?
                                <Spinner />
                            :
                            <Fragment>
                            <div
                                className={classes.itemImage}
                                onClick={(event) => {
                                    props.routProp.history.push(`/Detail?vehicle=${model.id}`)
                                }}>
                                <div className={classes.positioningCamera}>
                                    <img src={camera} alt='num' /><small>{model.media.length} +</small>
                                </div>
                                {tailer === '.mp4' ?
                                    <video width='100%' height='400px'>
                                        <source src={mediaImg} type='video/mp4' />
                                    </video>
                                    :
                                    <img src={mediaImg} alt='car images' />
                                }
                                <div className={classes.positioningHeart}>
                                    <img src={heart} alt='num' />
                                </div>
                            </div>
                            <div
                                className={classes.ItemInfo}
                                onClick={(event) => {
                                    props.routProp.history.push(`/Detail?vehicle=${model.id}`)
                                }}>
                                <h1>{model.title}</h1>
                                <div className={classes.Info}>
                                    <div className={classes.SellerPitch}>
                                        <img src={doubleQoute} alt='' />
                                        <p>Seller's Picthc </p>
                                        {model.seller_pitch}
                                    </div>
                                    <div className={classes.ItemDetails}>
                                        <div className={classes.DetailsRow}>
                                            <p className={classes.Btn}>{model.condition}</p>
                                            {model.is_featured ? <p className={classes.Btn}>Featured</p> : null}
                                            <p className={classes.Btn}>{model.body_type}</p>
                                        </div>
                                        <div className={`${classes.DetailsRow} ${classes.Light}`}>
                                            <p>Driven :</p>
                                            <p>Origin :</p>
                                            <p>Transmission :</p>
                                        </div>
                                        <div className={`${classes.DetailsRow} ${classes.Dark}`}>
                                            <p>{model.driven_wheel}</p>
                                            <p>{model.origin}</p>
                                            <p>{model.transmission}</p>
                                        </div>
                                        <div className={`${classes.DetailsRow} ${classes.Light}`}>
                                            <p>Fuel :</p>
                                            <p>Mileage :</p>
                                            <p>Location :</p>
                                        </div>
                                        <div className={`${classes.DetailsRow} ${classes.Dark}`}>
                                            <p>{model.fuel_type}</p>
                                            <p>{model.mileage}</p>
                                            <p>{model.state}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.Dealer}>
                                <div className={classes.DealerInfo}>
                                    <img src={unKnownDealer} alt='Dealer' width='50px' />
                                    <div className={classes.DealerDetila}>
                                        <h2>{model.seller.name}</h2>
                                        <p> {model.seller.company_name ? 'Company' : 'Private'} <img src={Like} width='14%' alt='' /></p>
                                        <div>
                                            <img src={Yellowstar} alt='' />
                                            <img src={Yellowstar} alt='' />
                                            <img src={Yellowstar} alt='' />
                                            <img src={Yellowstar} alt='' />
                                            <img src={EmptyYellowstar} alt='' />
                                        </div>
                                    </div>
                                </div>
                                <button className={classes.BtnBig}>
                                    RM {model.price.toString().slice(0, 3)} K
                            </button>
                                <button className={classes.BtnColored} onClick={()=>{
                                    props.toggelContactNow(model.seller.id, model.seller.name, model.seller.phone)
                                }}>
                                    Contact Now
                            </button>
                                <button
                                    className={classes.BtnRemove}
                                    onClick={() => {
                                        setCurrentItemToDel(model.id)
                                        let token = localStorage.getItem('idToken')
                                        if (!token) {
                                            const fireUser = auth.currentUser
                                            if (fireUser) {
                                                fireUser.getIdToken().then(newToken => {
                                                    localStorage.setItem('idToken', newToken)
                                                    token = newToken
                                                    props.RemoveItemFromWishList(model.id, token)
                                                })
                                            }
                                            else {
                                                console.log(fireUser)
                                            }
                                        }
                                        else {
                                            props.RemoveItemFromWishList(model.id, token)
                                        }
                                    }}>
                                    Remove post
                            </button>
                            </div>
                            </Fragment>
                    }

                    </div>
                );
            });
        return (
            <div className={classes.ListView}>
                {wishItem}
            </div>
        );
    }
};

export default WishList;